// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19MER","content":"styles_content__1kefH","tableWrap":"styles_tableWrap__2O8xH"};